import { render, staticRenderFns } from "./LogisticsList.vue?vue&type=template&id=6670974e&"
import script from "./LogisticsList.vue?vue&type=script&lang=js&"
export * from "./LogisticsList.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports